import { createStructuredSelector } from 'reselect';
import {
    TASK_LIST,
    TASK_LIST_SUCCESS,
    TASK_LIST_ERROR,
    TASK_PAGE_SET,
    TASK_DETAIL,
    TASK_DETAIL_SUCCESS,
    TASK_DETAIL_ERROR,
    TASK_VIEW_MODAL_SET,
    TASK_DETAIL_LIST,
    TASK_DETAIL_LIST_SUCCESS,
    TASK_DETAIL_LIST_ERROR,
    TASK_DETAIL_ADD,
    TASK_DETAIL_ADD_SUCCESS,
    TASK_DETAIL_ADD_ERROR,
    TASK_DETAIL_ADD_CHANGE,
    DELIVERY_PLAN_TASK_UPDATE,
    DELIVERY_PLAN_TASK_UPDATE_SUCCESS,
    DELIVERY_PLAN_TASK_UPDATE_ERROR,
} from '../actions';

export const TaskList = (page, num_page) => ({
    type: TASK_LIST,
    payload: { page, num_page }
});

export const TaskListSuccess = (data) => ({
    type: TASK_LIST_SUCCESS,
    payload: data
});

export const TaskListError = (error) => ({
    type: TASK_LIST_ERROR,
    payload: error
});

export const TaskPageSet = (data) => ({
    type: TASK_PAGE_SET,
    payload: data
});

export const TaskDetail = (data) => ({
    type: TASK_DETAIL,
    payload: data
});

export const TaskDetailSuccess = (data) => ({
    type: TASK_DETAIL_SUCCESS,
    payload: data
});

export const TaskDetailError = (error) => ({
    type: TASK_DETAIL_ERROR,
    payload: error
});

export const TaskViewModalSet = (data) => ({
    type: TASK_VIEW_MODAL_SET,
    payload: data
});

export const TaskDetailListAction = (data) => ({
    type: TASK_DETAIL_LIST,
    payload: data
});

export const TaskDetailListSuccess = (data) => ({
    type: TASK_DETAIL_LIST_SUCCESS,
    payload: data
});

export const TaskDetailListError = (error) => ({
    type: TASK_DETAIL_LIST_ERROR,
    payload: error
});

export const TaskDetailAddAction = (data) => ({
    type: TASK_DETAIL_ADD,
    payload: data
});

export const TaskDetailAddSuccess = (data) => ({
    type: TASK_DETAIL_ADD_SUCCESS,
    payload: data
});

export const TaskDetailAddError = (error) => ({
    type: TASK_DETAIL_ADD_ERROR,
    payload: error
});

export const TaskDetailAddChangeSet = (data) => ({
    type: TASK_DETAIL_ADD_CHANGE,
    payload: data
});

export const DeliveryPlanTaskUpdate = (data) => ({
    type: DELIVERY_PLAN_TASK_UPDATE,
    payload: data
});

export const DeliveryPlanTaskUpdateSuccess = (data) => ({
    type: DELIVERY_PLAN_TASK_UPDATE_SUCCESS,
    payload: data
});

export const DeliveryPlanTaskUpdateError = (error) => ({
    type: DELIVERY_PLAN_TASK_UPDATE_ERROR,
    payload: error
});


const task = (state) => state.task;

export const TaskSelector = createStructuredSelector({ task });
